import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-md-3" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_12 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_13 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_14 = {
  class: "p-input-icon-left",
  style: {"width":"20em"}
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Không có dữ liệu ")
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Không có dữ liệu ")
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Không có dữ liệu ")
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Không có dữ liệu ")
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Không có thông tin CheckIn/CheckOut. ")
const _hoisted_43 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_44 = { id: "loadingExport" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Đang tải dữ liệu, vui lòng chờ...", -1)
const _hoisted_46 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_47 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_48 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_49 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_50 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_51 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_52 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_53 = {
  class: "p-input-icon-left",
  style: {"width":"20em"}
}
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Không có dữ liệu ")
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Không có dữ liệu ")
const _hoisted_56 = { key: 0 }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Trực ")
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Không có thông tin CheckIn/CheckOut ca trực. ")
const _hoisted_60 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_61 = { id: "loadingExport" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Đang tải dữ liệu, vui lòng chờ...", -1)
const _hoisted_63 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_64 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_65 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" Checkin sáng ")
const _hoisted_67 = { key: 1 }
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Checkin sáng trễ")
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" Checkout sáng")
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Checkin chiều")
const _hoisted_72 = { key: 1 }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Checkin chiều trễ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Checkout chiều")
const _hoisted_75 = { key: 1 }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Không có thông tin CheckIn/CheckOut. ")
const _hoisted_77 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_78 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_79 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" Checkin trực ")
const _hoisted_81 = { key: 1 }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" Checkout trực")
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Không có thông tin CheckIn/CheckOut. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Label = _resolveComponent("Label")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, { header: "Thống kê CheckIn/CheckOut theo tháng" }, {
          default: _withCtx(() => [
            _createVNode(_component_Panel, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_Calendar, {
                      id: "dateMonth",
                      modelValue: $setup.dateMonth,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateMonth) = $event)),
                      selectionMode: "single",
                      view: "month",
                      dateFormat: "mm/yy",
                      showButtonBar: true,
                      showIcon: true,
                      manualInput: false,
                      monthNavigator: true,
                      yearNavigator: true,
                      yearRange: "2000:2100",
                      onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendar())),
                      onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_Dropdown, {
                      modelValue: $setup.idDepartment,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.idDepartment) = $event)),
                      options: $setup.listDepartment,
                      optionLabel: "name",
                      optionValue: "id",
                      placeholder: "Chọn khoa/ phòng",
                      filter: true
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_Button, {
                      label: "Xử lý",
                      icon: "pi pi-spinner",
                      iconPos: "left",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.exportFileMonth())),
                      disabled: $setup.dateMonth
                    }, null, 8, ["disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Button, {
                      label: "Tải danh sách",
                      icon: "pi pi-download",
                      iconPos: "left",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.downLoadFileExport($setup.fileNameMonth, 2))),
                      severity: "warning",
                      disabled: !$setup.downloadFile
                    }, null, 8, ["disabled"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "Thống kê CheckIn/CheckOut chi tiết theo ngày" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Calendar, {
                  id: "date",
                  modelValue: $setup.date,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.date) = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  showButtonBar: true,
                  showIcon: true,
                  manualInput: false,
                  monthNavigator: true,
                  yearNavigator: true,
                  yearRange: "2000:2100",
                  onDateSelect: _cache[7] || (_cache[7] = ($event: any) => ($setup.selectCalendar())),
                  onClearClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.clearCalendar()))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Dropdown, {
                  modelValue: $setup.idSelect,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.idSelect) = $event)),
                  options: $setup.listLate,
                  optionLabel: "label",
                  optionValue: "value",
                  placeholder: "Chọn hình thức trễ",
                  filter: true,
                  onChange: $setup.selectKind
                }, null, 8, ["modelValue", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Dropdown, {
                  modelValue: $setup.nameDepart,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.nameDepart) = $event)),
                  options: $setup.listDepart,
                  optionLabel: "name",
                  optionValue: "name",
                  placeholder: "Chọn khoa/ phòng",
                  onChange: $setup.selectKind,
                  filter: true
                }, null, 8, ["modelValue", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Button, {
                  label: "Xử lý",
                  icon: "pi pi-spinner",
                  iconPos: "left",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.exportFile())),
                  disabled: $setup.listThongKeDiemDanh.length < 1
                }, null, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Button, {
                  label: "Tải danh sách",
                  icon: "pi pi-download",
                  iconPos: "left",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.downLoadFileExport($setup.fileName, 0))),
                  severity: "warning",
                  disabled: !$setup.downloadFile
                }, null, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_DataTable, {
                  value: $setup.listThongKeDiemDanh,
                  paginator: true,
                  stripedRows: "",
                  rows: 20,
                  rowsPerPageOptions: [20,50,150],
                  rowHover: true,
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: ['fullName','phoneNumber','team'],
                  showGridlines: "",
                  currentPageReportTemplate: "Có tất cả {totalRecords} dữ liệu",
                  filters: $setup.filters,
                  "onUpdate:filters": _cache[15] || (_cache[15] = ($event: any) => (($setup.filters) = $event)),
                  style: {"font-size":"13px"}
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Button, {
                        type: "button",
                        icon: "pi pi-filter-slash",
                        label: "Xoá",
                        class: "p-button-outlined",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.clearFilter())),
                        style: {"width":"6em"}
                      }),
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_InputText, {
                          modelValue: $setup.filters['global'].value,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.filters['global'].value) = $event)),
                          placeholder: "Tìm theo tên hoặc số điện thoại"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  empty: _withCtx(() => [
                    _hoisted_42
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      header: "Stt",
                      headerStyle: "width:3rem"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "fullName",
                      header: "Họ và tên",
                      sortable: "",
                      style: {"font-weight":"bolder","width":"150px"}
                    }),
                    _createVNode(_component_Column, {
                      field: "phoneNumber",
                      header: "Số điện thoại",
                      sortable: "",
                      style: {"width":"80px"}
                    }),
                    _createVNode(_component_Column, {
                      field: "team",
                      header: "Khoa/ Phòng",
                      sortable: "",
                      style: {"font-weight":"bolder","width":"100px"}
                    }),
                    _createVNode(_component_Column, {
                      field: "checkInMorning",
                      header: "Checkin sáng",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (data.checkInMorningImage)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    style: {"font-size":"12px","font-weight":"bolder"},
                                    severity: "success"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" CheckIn sáng " + _toDisplayString($setup.formatDateTime(data.checkInMorning)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_Button, {
                                    key: 1,
                                    style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                    severity: "secondary"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_18
                                    ]),
                                    _: 1
                                  }))
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "checkInAfternoonLatest",
                      dataType: "date",
                      header: "Checkin sang trễ",
                      sortable: "",
                      style: {"width":"130px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_20
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              (data.checkInMorningLatestImage)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_Button, {
                                      label: "Chi tiết",
                                      style: {"font-size":"12px","font-weight":"bolder"},
                                      severity: "danger"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Checkin chiều trễ " + _toDisplayString($setup.formatDateTime(data.checkInMorningLatest)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "checkOutMorning",
                      dataType: "date",
                      header: "Checkout sáng",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              (data.checkOutMorningImage)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    style: {"font-size":"12px","font-weight":"bolder"},
                                    severity: "warning"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Checkout sáng " + _toDisplayString($setup.formatDateTime(data.checkOutMorning)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_Button, {
                                    key: 1,
                                    style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                    severity: "secondary"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_26
                                    ]),
                                    _: 1
                                  }))
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "checkInAfternoon",
                      dataType: "date",
                      header: "Checkin chiều",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (data.checkInAfternoonImage)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    style: {"font-size":"12px","font-weight":"bolder"},
                                    severity: "success"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Checkin chiều " + _toDisplayString($setup.formatDateTime(data.checkInAfternoon)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_Button, {
                                    key: 1,
                                    style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                    severity: "secondary"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  }))
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "checkInAfternoonLatest",
                      dataType: "date",
                      header: "Checkin chiều trễ",
                      sortable: "",
                      style: {"width":"130px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_32
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              (data.checkInAfternoonLatestImage)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createVNode(_component_Button, {
                                      label: "Chi tiết",
                                      style: {"font-size":"12px","font-weight":"bolder"},
                                      severity: "danger"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Checkin chiều trễ " + _toDisplayString($setup.formatDateTime(data.checkInAfternoonLatest)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "checkOutAfternoon",
                      dataType: "date",
                      header: "Checkout chiều",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_36
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              (data.checkOutAfternoonImage)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    label: "Chi tiết",
                                    style: {"font-size":"12px","font-weight":"bolder"},
                                    severity: "warning"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Checkout chiều " + _toDisplayString($setup.formatDateTime(data.checkOutAfternoon)), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_Button, {
                                    key: 1,
                                    label: "Chi tiết",
                                    style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                    severity: "secondary"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_38
                                    ]),
                                    _: 1
                                  }))
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "hours",
                      dataType: "date",
                      header: "Thời gian",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        _createVNode(_component_Label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.hours) + " giờ ", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "",
                      header: "Chi tiết",
                      sortable: "",
                      style: {"width":"70px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_40
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createVNode(_component_Button, {
                                label: "Chi tiết",
                                style: {"font-size":"12px","font-weight":"bolder"},
                                icon: "pi pi-eye",
                                severity: "info",
                                onClick: ($event: any) => ($setup.showDetailThongKe(data.id))
                              }, null, 8, ["onClick"])
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ColumnGroup, { type: "footer" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              footer: "Tổng cộng:",
                              colspan: 4,
                              footerStyle: "text-align:right"
                            }),
                            _createVNode(_component_Column, { footer: $setup.checkInMorningCount }, null, 8, ["footer"]),
                            _createVNode(_component_Column, { footer: "" }),
                            _createVNode(_component_Column, { footer: $setup.checkOutMorningCount }, null, 8, ["footer"]),
                            _createVNode(_component_Column, { footer: $setup.checkInAfternoonCount }, null, 8, ["footer"]),
                            _createVNode(_component_Column, { footer: "" }),
                            _createVNode(_component_Column, { footer: $setup.checkOutAfternoonCount }, null, 8, ["footer"]),
                            _createVNode(_component_Column, { footer: "" }),
                            _createVNode(_component_Column, { footer: "" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_Dialog, {
                  header: "Đang xử lý",
                  visible: $setup.loadingData,
                  "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (($setup.loadingData) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode(_component_ProgressBar, {
                        mode: "indeterminate",
                        style: {"height":".3em"}
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode(_component_ConfirmDialog)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, { header: "Thống kê Trực" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_Calendar, {
                  id: "date",
                  modelValue: $setup.dateOverTime,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.dateOverTime) = $event)),
                  selectionMode: "single",
                  dateFormat: "dd/mm/yy",
                  showButtonBar: true,
                  showIcon: true,
                  manualInput: false,
                  monthNavigator: true,
                  yearNavigator: true,
                  yearRange: "2000:2100",
                  onDateSelect: _cache[18] || (_cache[18] = ($event: any) => ($setup.selectCalendarOverTime())),
                  onClearClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.clearCalendar()))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_Dropdown, {
                  modelValue: $setup.nameDepartOverTime,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.nameDepartOverTime) = $event)),
                  options: $setup.listDepartOverTime,
                  optionLabel: "name",
                  optionValue: "name",
                  placeholder: "Chọn khoa/ phòng",
                  onChange: $setup.selectKindOverTime,
                  filter: true
                }, null, 8, ["modelValue", "options", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_Button, {
                  label: "Xử lý",
                  icon: "pi pi-spinner",
                  iconPos: "left",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.exportFileOverTime())),
                  disabled: $setup.listThongKeTruc.length < 1
                }, null, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_Button, {
                  label: "Tải danh sách",
                  icon: "pi pi-download",
                  iconPos: "left",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => ($setup.downLoadFileExport($setup.fileNameTruc, 1))),
                  severity: "warning",
                  disabled: !$setup.downloadFile
                }, null, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_DataTable, {
                  value: $setup.listThongKeTruc,
                  paginator: true,
                  stripedRows: "",
                  rows: 20,
                  rowsPerPageOptions: [20,50,150],
                  rowHover: true,
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: ['fullName','phoneNumber','team'],
                  showGridlines: "",
                  currentPageReportTemplate: "Có tất cả {totalRecords} dữ liệu",
                  filters: $setup.filters,
                  "onUpdate:filters": _cache[25] || (_cache[25] = ($event: any) => (($setup.filters) = $event)),
                  style: {"font-size":"13px"}
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_Button, {
                        type: "button",
                        icon: "pi pi-filter-slash",
                        label: "Xoá",
                        class: "p-button-outlined",
                        onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.clearFilter())),
                        style: {"width":"6em"}
                      }),
                      _createElementVNode("span", _hoisted_53, [
                        _createVNode(_component_InputText, {
                          modelValue: $setup.filters['global'].value,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.filters['global'].value) = $event)),
                          placeholder: "Tìm theo tên hoặc số điện thoại"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  empty: _withCtx(() => [
                    _hoisted_59
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      header: "Stt",
                      headerStyle: "width:3rem"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "fullName",
                      header: "Họ và tên",
                      sortable: "",
                      style: {"font-weight":"bolder","width":"150px"}
                    }),
                    _createVNode(_component_Column, {
                      field: "phoneNumber",
                      header: "Số điện thoại",
                      sortable: "",
                      style: {"width":"80px"}
                    }),
                    _createVNode(_component_Column, {
                      field: "team",
                      header: "Khoa/ Phòng",
                      sortable: "",
                      style: {"font-weight":"bolder","width":"100px"}
                    }),
                    _createVNode(_component_Column, {
                      field: "checkIn",
                      header: "Checkin trực",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.checkInImage)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              style: {"font-size":"12px","font-weight":"bolder"},
                              severity: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.formatDateTime(data.checkIn)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                              severity: "secondary"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_54
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "checkOut",
                      dataType: "date",
                      header: "Checkout trực",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.checkOutImage)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              label: "Chi tiết",
                              style: {"font-size":"12px","font-weight":"bolder"},
                              severity: "warning"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.formatDateTime(data.checkOut)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              label: "Chi tiết",
                              style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                              severity: "secondary"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_55
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "hours",
                      dataType: "date",
                      header: "Thời gian",
                      sortable: "",
                      style: {"width":"120px"}
                    }, {
                      body: _withCtx(({data}) => [
                        _createVNode(_component_Label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(data.hours) + " giờ ", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "",
                      header: "Chi tiết",
                      sortable: "",
                      style: {"width":"70px"}
                    }, {
                      body: _withCtx(({data}) => [
                        (data.overTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createVNode(_component_Button, {
                                style: {"font-size":"12px","font-weight":"bolder","display":"table-cell","vertical-align":"middle"},
                                severity: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_57
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _createVNode(_component_Button, {
                                label: "Chi tiết",
                                style: {"font-size":"12px","font-weight":"bolder"},
                                icon: "pi pi-eye",
                                severity: "info",
                                onClick: ($event: any) => ($setup.showDetailThongKeTruc(data.id))
                              }, null, 8, ["onClick"])
                            ]))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ColumnGroup, { type: "footer" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              footer: "Tổng cộng:",
                              colspan: 4,
                              footerStyle: "text-align:right"
                            }),
                            _createVNode(_component_Column, { footer: $setup.checkInOverTime }, null, 8, ["footer"]),
                            _createVNode(_component_Column, { footer: $setup.checkOutOverTime }, null, 8, ["footer"]),
                            _createVNode(_component_Column, { footer: "" }),
                            _createVNode(_component_Column, { footer: "" })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters"])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_component_Dialog, {
                  header: "Đang xử lý",
                  visible: $setup.loadingData,
                  "onUpdate:visible": _cache[26] || (_cache[26] = ($event: any) => (($setup.loadingData) = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createVNode(_component_ProgressBar, {
                        mode: "indeterminate",
                        style: {"height":".3em"}
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode(_component_ConfirmDialog)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_63, [
      _createVNode(_component_Dialog, {
        visible: $setup.showDetail,
        "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => (($setup.showDetail) = $event)),
        style: { width: '90vw'},
        breakpoints: { '1500px': '90vw', '1150px': '95vw' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Panel, { header: "Thông tin chi tiết CheckIn/CheckOut" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createVNode(_component_DataTable, {
                    value: $setup.thongKeDiemDanh,
                    stripedRows: "",
                    rows: 10,
                    rowHover: true,
                    globalFilterFields: ['fullName','phoneNumber','team'],
                    showGridlines: "",
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[27] || (_cache[27] = ($event: any) => (($setup.filters) = $event)),
                    style: {"font-size":"13px"}
                  }, {
                    empty: _withCtx(() => [
                      _hoisted_76
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "fullName",
                        header: "Họ và tên",
                        sortable: "",
                        style: {"font-weight":"bolder","width":"150px"}
                      }),
                      _createVNode(_component_Column, {
                        field: "phoneNumber",
                        header: "Số điện thoại",
                        sortable: "",
                        style: {"width":"80px"}
                      }),
                      _createVNode(_component_Column, {
                        field: "team",
                        header: "Khoa/ Phòng",
                        sortable: "",
                        style: {"font-weight":"bolder","width":"100px"}
                      }),
                      _createVNode(_component_Column, {
                        field: "checkInMorning",
                        header: "Checkin sáng",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkInMorningImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_66
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkInMorningImage,
                                    alt: data.checkInMorningImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkInMorning),
                                    severity: "success"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _createVNode(_component_Tag, {
                                  value: "Không có dữ liệu",
                                  severity: "contrast"
                                })
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "checkInMorningLatest",
                        dataType: "date",
                        header: "Checkin sáng trễ",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkInMorningLatestImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_68
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkInMorningLatestImage,
                                    alt: data.checkInMorningLatestImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkInMorningLatest),
                                    severity: "danger"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "checkOutMorning",
                        dataType: "date",
                        header: "Checkout sáng",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkOutMorningImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_69
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkOutMorningImage,
                                    alt: data.checkOutMorningImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkOutMorning),
                                    severity: "warning"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _createVNode(_component_Tag, {
                                  value: "Không có dữ liệu",
                                  severity: "contrast"
                                })
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "checkInAfternoon",
                        dataType: "date",
                        header: "Checkin chiều",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkInAfternoonImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_71
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkInAfternoonImage,
                                    alt: data.checkInAfternoonImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkInAfternoon),
                                    severity: "success"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                _createVNode(_component_Tag, {
                                  value: "Không có dữ liệu",
                                  severity: "contrast"
                                })
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "checkInAfternoonLatest",
                        dataType: "date",
                        header: "Checkin chiều trễ",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkInAfternoonLatestImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_73
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkInAfternoonLatestImage,
                                    alt: data.checkInAfternoonLatestImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkInAfternoonLatest),
                                    severity: "danger"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "checkOutAfternoon",
                        dataType: "date",
                        header: "Checkout chiều",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkOutAfternoonImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_74
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkOutAfternoonImage,
                                    alt: data.checkOutAfternoonImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkOutAfternoon),
                                    severity: "warning"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                _createVNode(_component_Tag, {
                                  value: "Không có dữ liệu",
                                  severity: "contrast"
                                })
                              ]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ]),
    _createElementVNode("div", _hoisted_77, [
      _createVNode(_component_Dialog, {
        visible: $setup.showDetailTruc,
        "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => (($setup.showDetailTruc) = $event)),
        style: { width: '90vw'},
        breakpoints: { '1500px': '90vw', '1150px': '95vw' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Panel, { header: "Thông tin chi tiết CheckIn/CheckOut Trực" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createVNode(_component_DataTable, {
                    value: $setup.thongKeTruc,
                    stripedRows: "",
                    rows: 10,
                    rowHover: true,
                    globalFilterFields: ['fullName','phoneNumber','team'],
                    showGridlines: "",
                    filters: $setup.filters,
                    "onUpdate:filters": _cache[29] || (_cache[29] = ($event: any) => (($setup.filters) = $event)),
                    style: {"font-size":"13px"}
                  }, {
                    empty: _withCtx(() => [
                      _hoisted_83
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Column, {
                        field: "fullName",
                        header: "Họ và tên",
                        sortable: "",
                        style: {"font-weight":"bolder","width":"150px"}
                      }),
                      _createVNode(_component_Column, {
                        field: "phoneNumber",
                        header: "Số điện thoại",
                        sortable: "",
                        style: {"width":"80px"}
                      }),
                      _createVNode(_component_Column, {
                        field: "team",
                        header: "Khoa/ Phòng",
                        sortable: "",
                        style: {"font-weight":"bolder","width":"100px"}
                      }),
                      _createVNode(_component_Column, {
                        field: "checkIn",
                        header: "Checkin trực",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkInImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_80
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkInImage,
                                    alt: data.checkInImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkIn),
                                    severity: "success"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                _createVNode(_component_Tag, {
                                  value: "Không có dữ liệu",
                                  severity: "contrast"
                                })
                              ]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Column, {
                        field: "checkOut",
                        dataType: "date",
                        header: "Checkout trực",
                        sortable: "",
                        style: {"width":"100px"}
                      }, {
                        body: _withCtx(({data}) => [
                          (data.checkOutImage)
                            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                                title: _withCtx(() => [
                                  _hoisted_82
                                ]),
                                content: _withCtx(() => [
                                  _createVNode(_component_Image, {
                                    src: data.checkOutImage,
                                    alt: data.checkOutImage,
                                    width: "100",
                                    preview: ""
                                  }, null, 8, ["src", "alt"])
                                ]),
                                footer: _withCtx(() => [
                                  _createVNode(_component_Tag, {
                                    value: $setup.formatDateTime(data.checkOut),
                                    severity: "danger"
                                  }, null, 8, ["value"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "filters"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ], 64))
}